import React from "react";
import { Box, Card, CardContent, Stack, Typography } from "@mui/material";
import { assetIcons } from "../../../constants/assets"; // Importing static asset
import { darkColors } from "../../../theme/colors";
import { fontSizes } from "../../../theme/font-sizes";
import InlineSvg from "../inline-svg";

const BetDetails = ({ bets, isMediumScreen }) => {
  return (
    <Card
      sx={{
        maxWidth: isMediumScreen ? "100%" : 400,
        borderRadius: "12px",
        background: darkColors.popupBgTop,
        border: "1px solid",
        borderColor: darkColors.borderGray,
      }}
    >
      <CardContent sx={{ p: 0 }}>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          p={3}
        >
          <Typography
            textAlign={"left"}
            color="white"
            fontSize={fontSizes.heading3}
            fontWeight={700}
          >
            Your Bets
          </Typography>
          <Stack direction="row" alignItems="center" gap={0.5}>
            <InlineSvg
              sx={{ mr: 0.4, mt: 0.8 }}
              url={assetIcons.currencyIcon}
            />
            <Typography color={darkColors.lightGray} fontSize={fontSizes.body}>
              {bets.reduce((sum, bet) => sum + bet.amount, 0)}
            </Typography>
          </Stack>
        </Stack>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb={2}
          px={3}
        >
          <Typography color={darkColors.lightGray} fontSize={fontSizes.body}>
            Racer
          </Typography>
          <Stack direction="row" alignItems="center" gap={0.5}>
            <InlineSvg
              sx={{ mr: 0.4, mt: 0.8 }}
              url={assetIcons.currencyIcon}
            />
            <Typography color={darkColors.lightGray} fontSize={fontSizes.body}>
              Amount
            </Typography>
          </Stack>
        </Box>
        <Box
          sx={{
            "&::-webkit-scrollbar-track": {
              background: "transparent", // Hides scrollbar track
            },
            maxHeight: "220px", // Adjust height to fit 4 items
            overflowY: bets.length > 4 ? "auto" : "visible", // Enable scroll only if bets exceed 4
            background: "transparent", // Optional, for consistency
          }}
        >
          {bets.length > 0 ? (
            bets.map((bet, index) => (
              <React.Fragment key={index}>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  py={2}
                  px={3}
                  sx={{
                    background: bet.amount >= 0 ? "transparent" : "#181818",
                  }}
                >
                  <Typography color="white" fontSize={fontSizes.heading3}>
                    {bet.racer}
                  </Typography>
                  <Typography
                    fontSize={fontSizes.heading3}
                    color={bet.amount >= 0 ? darkColors.green : darkColors.red}
                  >
                    {bet.amount >= 0 ? `+${bet.amount}` : bet.amount}
                  </Typography>
                </Box>
              </React.Fragment>
            ))
          ) : (
            <Typography
              color="white"
              fontSize={fontSizes.heading3}
              textAlign="center"
              py={1}
            >
              No bets yet
            </Typography>
          )}
        </Box>
      </CardContent>
    </Card>
  );
};

export default BetDetails;
